import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'

import ContentLoader from 'components/loaders/ContentLoader/ContentLoader'


const ContentLoaderAwareOfRequestLoader = ({ className, isHidden }) => !isHidden && (
  <ContentLoader className={className} />
)

ContentLoaderAwareOfRequestLoader.propTypes = {
  className: PropTypes.string,
  isHidden: PropTypes.bool,
}


export default connect({
  isHidden: 'models.ui.isRequestLoaderVisible',
})(ContentLoaderAwareOfRequestLoader)
